import { envelope } from './index'

export default function MoveItem(id, changeKey) {
  return envelope`
    <MoveItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">
      <ToFolderId>
        <t:DistinguishedFolderId Id="deleteditems"/>
      </ToFolderId>
      <ItemIds>
        <t:ItemId Id="${id}" ChangeKey="${changeKey}"/>
      </ItemIds>
    </MoveItem>
  `
}
